<div class="address-add-container">
  <div class="title" style="color: var(--black)">
    <h1>اضافه کردن آدرس</h1>
  </div>
  <mat-card>
    <mat-card-header>
      <mat-card-title></mat-card-title>
      <mat-card-subtitle
        >لطفا اطلاعات را با دقت فراوان وارد کنید</mat-card-subtitle
      >
    </mat-card-header>

    <div class="float-actions">
      <button mat-icon-button>
        <jam-icon name="more-vertical-f"></jam-icon>
      </button>
    </div>

    <mat-card-content>
      <form fxLayout="column" [formGroup]="form" class="add-address-form">
        <div
          class="box"
          fxLayout.lt-sm="column"
          fxLayout="row"
          fxLayoutAlign="space-evenly center"
        >
          <mat-form-field appearance="outline">
            <mat-label> نام گیرنده </mat-label>
            <input
              placeholder="مثال: مهدی رحیمی"
              formControlName="recipientName"
              type="text"
              matInput
              [(ngModel)]="dialogData.model.recipientName"
            />
          </mat-form-field>

          <mat-form-field appearance="outline">
            <mat-label> تلفن ثابت </mat-label>
            <input
              type="text"
              formControlName="landlinePhone"
              placeholder="مثال: ۰۳۱۵۷۵۹۳۱۰۲"
              inputmode="numeric"
              matInput
              [(ngModel)]="dialogData.model.landlinePhone"
            />
          </mat-form-field>
        </div>

        <div
          class="box"
          fxLayout.lt-sm="column"
          fxLayout="row"
          fxLayoutAlign="space-evenly center"
        >
          <mat-form-field appearance="outline">
            <mat-label> کد پستی </mat-label>
            <input
              placeholder="۱۰ رقم"
              formControlName="postalCode"
              inputmode="numeric"
              type="text"
              matInput
              [(ngModel)]="dialogData.model.postalCode"
            />
          </mat-form-field>

          <mat-form-field appearance="outline">
            <mat-label> تلفن همراه </mat-label>
            <input
              type="text"
              formControlName="phoneNumber"
              inputmode="numeric"
              matInput
              [(ngModel)]="dialogData.model.phoneNumber"
            />
          </mat-form-field>
        </div>

        <div
          class="box"
          fxLayout.lt-sm="column"
          fxLayout="row"
          fxLayoutAlign="space-evenly center"
        >
          <mat-form-field appearance="outline">
            <mat-label> استان </mat-label>
            <mat-select
              formControlName="province"
              (selectionChange)="updateCities($event)"
              [(ngModel)]="dialogData.model.province"
            >
              <mat-option
                [value]="province.name"
                *ngFor="let province of provinces"
              >
                {{ province.name }}
              </mat-option>
            </mat-select>
          </mat-form-field>

          <mat-form-field appearance="outline">
            <mat-label> شهر </mat-label>
            <mat-select
              formControlName="city"
              [(ngModel)]="dialogData.model.city"
            >
              <mat-option [value]="city.name" *ngFor="let city of cities">
                {{ city.name }}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>

        <div
          class="box"
          fxLayout.lt-sm="column"
          fxLayout="row"
          fxLayoutAlign="space-evenly center"
        >
          <mat-form-field appearance="outline" class="textarea" fxFlex="100">
            <mat-label> آدرس </mat-label>
            <textarea
              matInput
              formControlName="address"
              rows="10"
              [(ngModel)]="dialogData.model.address"
            ></textarea>
          </mat-form-field>
        </div>
      </form>

      <mat-card-actions>
        <button
          class="save-btn"
          [disabled]="!isValid()"
          (click)="addAddressSubmit()"
          color="primary"
          matTooltip="ذخیره"
          mat-flat-button
        >
          <span> ثبت آدرس </span>
          <jam-icon name="check"></jam-icon>
        </button>

        <button
          class="close-btn"
          (click)="close()"
          color="warn"
          mat-icon-button
        >
          <jam-icon name="close"></jam-icon>
        </button>
      </mat-card-actions>
    </mat-card-content>
  </mat-card>
</div>
